import { render } from "./MemberCard.vue?vue&type=template&id=2a54002e&scoped=true"
import script from "./MemberCard.vue?vue&type=script&lang=js"
export * from "./MemberCard.vue?vue&type=script&lang=js"

import "./MemberCard.vue?vue&type=style&index=0&id=2a54002e&scoped=true&lang=css"

import exportComponent from "/Users/alialsaady/Documents/repos/tandzorggestel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a54002e"]])

export default __exports__